export default {
  lookups: {},
  groups: [],
  timeZones: [],
  countries: [],
  stateProvinces: [],
  languages: [],
  calibrateReady: [],
  calibratePreCheckList: [],
  calibrateService: [],
  calibrateActionType: [],
  calibrateVerify: [],
  centerFirms: [],
  brand: [],
  newInsurance: null,
  search: '',
  selectedInsurance: null,
  insuranceLookup: [],
  sourceInsurance: [],
  insurance: [],
  pricingRules: []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js